import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Connects to data-controller="view-selector"
export default class extends Controller {
  static override targets = []
  static override values = {
    gardenId: Number,
    currentView: String
  }

  declare readonly gardenIdValue: number
  declare readonly currentViewValue: string

  private currentView: string = 'map'

  override connect() {
    this.currentView = this.currentViewValue || 'map'
  }

  switchToMap() {
    this.switchToView('map')
  }

  switchToTopDown() {
    this.switchToView('topdown')
  }

  switchToHeadOn() {
    this.switchToView('headon')
  }

  private switchToView(view: string) {
    if (view === this.currentView) {
      return
    }

    // Update button states immediately for better UX
    this.updateButtonStates(view)

    // Make the request using Turbo's built-in fetch handling
    // Turbo will automatically process the Turbo Stream response
    const url = `/gardens/${this.gardenIdValue}/view?view=${view}`

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.text()
      })
      .then(html => {
        // Let Turbo process the stream response
        Turbo.renderStreamMessage(html)

        // Update current view
        this.currentView = view

        // Dispatch custom event (unprefixed so listeners on document / ancestors work)
        this.dispatch('viewChanged', {
          detail: { view, gardenId: this.gardenIdValue },
          prefix: false,
          bubbles: true
        } as never)
      })
      .catch(() => {
        // Revert button states on error
        this.updateButtonStates(this.currentView)
      })
  }

  private updateButtonStates(activeView: string) {
    // Remove active class from all buttons
    const buttons = this.element.querySelectorAll('.view-selector__button')
    buttons.forEach(button => {
      button.classList.remove('active')
      button.setAttribute('aria-pressed', 'false')
    })

    // Add active class to the correct button
    const activeButton = this.element.querySelector(`.view-selector__button--${activeView}`)
    if (activeButton) {
      activeButton.classList.add('active')
      activeButton.setAttribute('aria-pressed', 'true')
    }
  }
}